import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';

const CalcularAluguel = () => {
    const [notaFiscal, setNotaFiscal] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitCalcularAluguel (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            notaFiscal
        });

        try {
            const response = await fetchFlask('calcularAluguel', body);
            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
            if (response.status === 'success') {
                setNotaFiscal('');
            }
        } finally {
            setIsSubmit(false);
        }
    };

    const notasList = notaFiscal
        .split(/[\s,;]+/)
        .map((nota) => nota.trim())
        .filter(Boolean);
    const completedFields = [notasList.length > 0].filter(Boolean).length;

    return (
        <Box className='mainBox ui-workflow-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Calcular Aluguel
            </PageHeader>

            <form action='' method='POST' id='formCalcularAluguel' onSubmit={submitCalcularAluguel} className='ui-workflow-layout'>
                <Box className='ui-workflow-workspace'>
                    <Box className='ui-workflow-intro'>
                        <Box>
                            <h2>Cálculo de aluguel por Nota Fiscal</h2>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-panel'>
                        <Box className='ui-heading'>
                            <ReceiptLongRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Notas fiscais para cálculo</strong>
                            </Box>
                        </Box>

                        <Box className='ui-input-strip'>
                            <SummarizeRoundedIcon />
                            <TextField
                                required
                                label='Nota fiscal'
                                id='notaFiscal'
                                multiline
                                minRows={5}
                                maxRows={10}
                                value={notaFiscal}
                                onChange={(e) => setNotaFiscal(e.target.value)}
                                placeholder='Uma nota fiscal por linha, ou separadas por vírgula'
                            />
                        </Box>
                    </Box>
                </Box>

                <Box className='ui-workflow-summary'>
                    <Box className='ui-heading ui-heading-divided'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do cálculo</strong>
                        </Box>
                    </Box>

                    <Box className='ui-workflow-summary-list'>
                        <Box>
                            <span>Notas fiscais</span>
                            <strong className={notasList.length === 0 ? 'is-empty' : undefined}>
                                {notasList.length === 0 ? 'Não informadas' : `${notasList.length} identificada${notasList.length === 1 ? '' : 's'}`}
                            </strong>
                        </Box>
                        <Box>
                            <span>Processo</span>
                            <strong>Calcular aluguel</strong>
                        </Box>
                    </Box>

                    <Box className='ui-attention'>
                        <RuleRoundedIcon />
                        <p>
                            Revise as notas fiscais antes de calcular. Todas as notas informadas serão enviadas para o processo.
                        </p>
                    </Box>

                    <Box className='ui-attention is-ok ui-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<CalculateRoundedIcon />}>
                        Calcular Aluguel
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default CalcularAluguel;
